import React from "react";

// Texts of the Google Business Profile audit results (header, score cards,
// tabs, lists of criteria, calls to action). Texts of the tabs' detail blocks
// are in FeaturesBlocks/content.jsx, criteria texts in criteria.js.
const content = {
  fr: {
    googleHl: "fr",
    incomplete: {
      title: "Données incomplètes",
      text: "Nous n'avons pas pu récupérer toutes les informations de votre fiche. Veuillez réessayer dans quelques instants.",
      retry: "Réessayer",
    },
    competition: { High: "Élevée", Low: "Faible", Medium: "Moyenne" },
    rated: (rating, count) => (
      <>
        Noté <strong>{rating}</strong>/5 sur <strong>{count}</strong> avis
      </>
    ),
    reviewLinkCta: "Obtenir votre lien direct pour collecter des avis",
    localScore: "Local Score",
    scoreHint: (score) =>
      score >= 90 ? "Excellent" : score >= 60 ? "Peut mieux faire" : "Insuffisant",
    validCount: "Critères valides",
    issuesCount: "Problèmes",
    competitionLabel: "Concurrence",
    tabs: {
      overview: "Vue d'ensemble",
      essentials: "Indispensables",
      informations: "Informations",
      social: "Réseaux sociaux",
      reviews: "Avis",
      engagement: "Engagement",
    },
    overviewTitle: "Détail de l'audit",
    issues: {
      title: "Problèmes détectés",
      empty: "Aucun problème détecté",
      status: "A corriger",
    },
    valid: {
      title: "Critères optimisés",
      empty: "Aucun critère optimisé détecté",
      status: "Validé",
    },
    lock: {
      cta: "Débloquez l'audit complet sur Localranker",
      remaining: (n) => `${n} autre(s) problème(s) à régler`,
    },
    cta: {
      badge: "Localranker",
      titleFull: "Devenez le meilleur établissement de votre secteur",
      titleLocked: "Débloquez l'audit complet de votre fiche GBP",
      descFull:
        "Découvrez Localranker, la plateforme de gestion et d'optimisation Google Business Profile.",
      descLocked:
        "Points bloquants, lien d'avis, analyse concurrentielle locale et recommandations personnalisées.",
      button: "Demander une démo gratuite",
    },
  },
  en: {
    googleHl: "en",
    incomplete: {
      title: "Incomplete data",
      text: "We couldn't retrieve all the information from your Google Business Profile. Please try again in a moment.",
      retry: "Try again",
    },
    competition: { High: "High", Low: "Low", Medium: "Medium" },
    rated: (rating, count) => (
      <>
        Rated <strong>{rating}</strong>/5 from{" "}
        <strong>{Number(count).toLocaleString("en-US")}</strong>{" "}
        {Number(count) === 1 ? "review" : "reviews"}
      </>
    ),
    reviewLinkCta: "Get your direct link to collect reviews",
    localScore: "Local Score",
    scoreHint: (score) =>
      score >= 90 ? "Excellent" : score >= 60 ? "Room to improve" : "Needs work",
    validCount: "Criteria met",
    issuesCount: "Issues",
    competitionLabel: "Competition",
    tabs: {
      overview: "Overview",
      essentials: "Essentials",
      informations: "Business info",
      social: "Social profiles",
      reviews: "Reviews",
      engagement: "Engagement",
    },
    overviewTitle: "Audit details",
    issues: {
      title: "Issues found",
      empty: "No issues found",
      status: "To fix",
    },
    valid: {
      title: "Optimized criteria",
      empty: "No optimized criteria found",
      status: "Passed",
    },
    lock: {
      cta: "Unlock the full audit on Localranker",
      remaining: (n) => `${n} more ${n === 1 ? "issue" : "issues"} to fix`,
    },
    cta: {
      badge: "Localranker",
      titleFull: "Become the top-rated business in your market",
      titleLocked: "Unlock your full Google Business Profile audit",
      descFull:
        "Discover Localranker, the platform to manage and optimize Google Business Profiles across all your locations.",
      descLocked:
        "Blocking issues, review link, local competitor analysis and personalized recommendations.",
      button: "Book a free demo",
    },
  },
};

export default content;
